export enum HeaderVariations {
  DEFAULT_PRIMARY = 'primary',
  DEFAULT_SECONDARY = 'secondary',
}
